import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

api.interceptors.request.use((config) => {
  config.headers["X-API-Key"] = "123456";
  return config;
});

export default api;